import styled from 'styled-components';
import {device} from '../../../../../utils/device';

export const FaqsCont = styled.div`
  background-color: #1a1a1a;
`;
export const FaqsInner = styled.div`
  max-width: 1200px;
  padding: 30px 0;
  margin: 0 auto;
  @media ${device.mobileS} {
    padding: 20px 16px;
  }
`;
export const FaqsHeading = styled.h3`
  font-size: 21px;
  line-height: 32px;
  font-weight: 900;
  color: #fff;
  margin-bottom: 24px;
  margin-top: 8px;

  @media ${device.mobileS} {
    font-size: 22px;
    line-height: 28px;
    margin-bottom: 10px;
  }
`;

export const headingDiv = styled.div`
  
  line-height: 24px;
  font-weight: 900;
  color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  .heading {
    font-size: 21px !important;
  }
  font-size: 16px;
  
  
  ${p =>
    p.isActive &&
    `
    
  `}
  @media ${device.mobileS} {
    font-size: 16px;
    line-height: 19px;
    padding-right: 30px;
  }
  
`;
export const FaqsRow = styled.div`
  padding: 15px 0;
`;
export const FaqsQuestion = styled.h4`
  line-height: 24px;
  font-weight: 900;
  color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  .heading {
    font-size: 21px !important;
  }
  font-size: 16px;
 
  ${p =>
    p.isActive &&
    `
    &::after{
      content: "";
      display: inline-flex;
      border: solid #757575;
      border-width: 0 2px 2px 0;
      padding: 4px;
      transition: all 0.3s linear;
      transform: rotate(-135deg);
      width: unset;
      height: unset;
      background-color: unset;
    }
    &::before{
      display: none;
    }
  `}
  @media ${device.mobileS} {
    font-size: 16px;
    line-height: 19px;
    padding-right: 30px;
  }
`;

export const FaqsHeadingQuestion = styled.h4`
  line-height: 24px;
  font-weight: 900;
  color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  .heading {
    font-size: 21px !important;
  }
  font-size: 16px;
  @media ${device.mobileS} {
    font-size: 16px;
    line-height: 19px;
    padding-right: 30px;
  }
`;

export const FaqsList = styled.ul`
  margin-top: 20px;
  li {
    list-style: none;
  }
  li {
    white-space: pre-line;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    color: #fff;
    margin-bottom: 10px;
    position: relative;
    padding-left: 15px;
    ::before {
      //width: 5px;
      //height: 5px;
      position: absolute;
      display: -webkit-inline-box;
      display: -webkit-inline-flex;
      display: -ms-inline-flexbox;
      display: inline-flex;
      background-color: #fff;
      content: '';
      border-radius: 50%;
      top: 7px;
      left: 0;
      splay: none;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  @media ${device.mobileS} {
    li {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;
